//imports
import {
    PM_USERS_DELETE_USER_OPEN_MODAL,
    PM_USERS_DELETE_USER_CLOSE_MODAL,
    PM_USERS_DELETE_USER_REQUEST,
    PM_USERS_DELETE_USER_RESULT,
} from 'Redux/actionTypes';

export const deletePMUserOpenModal = (items) => ({
    type: PM_USERS_DELETE_USER_OPEN_MODAL,
    payload: items,
});

export const deletePMUserCloseModal = () => ({
    type: PM_USERS_DELETE_USER_CLOSE_MODAL
});

export const deletePMUserRequest = (items) => ({
    type: PM_USERS_DELETE_USER_REQUEST,
    payload: { items },
});

export const deletePMUserResult = (result) => ({
    type: PM_USERS_DELETE_USER_RESULT,
    payload: result
});
